const extractDomainName = (o) => {
    try {
        return o.attributes.name;
    } catch (e) {
        return undefined;
    }
};

const extractChildren = (o, level) => {
    const children = [];
    /* eslint-disable */
    for (const name in o) {
        if (o.hasOwnProperty(name) && name !== "attributes") {
            children.push(new Domain(name, o[name], level));
        }
    }
    /* eslint-enable */
    return children;
};


/**
 * Represents a Domain node in the Cloud Connect domain tree.
 * Each node has an id an optional name and zero or more children
 * nodes.
 *
 * The level is the level from the root node.
 */
export default class Domain {
    constructor(domainId, domainData, level = 0) {
        this.id = domainId;
        this.level = level;
        this.name = extractDomainName(domainData) || this.id;
        this.children = extractChildren(domainData, level + 1);
    }

    /**
     * Get a list of all domains from this node and any descendants
     */
    allChildren() {
        return this.children.reduce((prev, current) => {
            prev.push(current);
            return prev.concat(current.allChildren());
        }, []);
    }

    /**
     * Resolve the domain name based on the domain id within this
     * domains children, if no domain is found undefined is returned.
     *
     * @param {*} domainId The id of the domain
     */
    resolveName(domainId) {
        if (domainId === undefined) return domainId;
        if (this.id === domainId) return this.name;

        for (let i = 0; i < this.children.length; i += 1) {
            const childResult = this.children[i].resolveName(domainId);
            if (childResult !== undefined) return childResult;
        }
        return undefined;
    }

    /**
     * Resolves the domain path `domain/domain/domain` up to the given
     * domain id.
     *
     * If the given domain name is not found, undefined is returned.
     *
     * @param {*} domainId  The id of the domain to resolve path to
     */
    resolvePath(domainId) {
        if (domainId === undefined) return domainId;
        if (this.id === domainId) return this.id;

        for (let i = 0; i < this.children.length; i += 1) {
            const childResult = this.children[i].resolvePath(domainId);
            if (childResult !== undefined) {
                return `${this.id}/${childResult}`;
            }
        }

        return undefined;
    }

    /**
     * Resolves a trail of objects used when creating a breadcrumb in the
     * UI.
     *
     * @param {*} domainId  The id of the domain to resolve path to
     * @return An array of all domain objects for the resulting path. E.g.
     * [{id, name}, {id, name}]
     */
    trail(domainId) {
        if (this.id === domainId) return [{ id: this.id, name: this.name }];

        for (let i = 0; i < this.children.length; i += 1) {
            const childResult = this.children[i].trail(domainId);
            if (childResult !== undefined) {
                return [{ id: this.id, name: this.name }].concat(childResult);
            }
        }

        return undefined;
    }

    /**
     * Get a list of all domain ID's for the current domain node and all its
     * children.
     */
    getAllIds() {
        const ids = [this.id];
        const children = this.allChildren().map(c => c.id);
        return ids.concat(children);
    }

    /**
     * Find the domain with the given Id or return undefined.
     */
    find(domainId) {
        if (this.id === domainId) return this;

        for (let i = 0; i < this.children.length; i += 1) {
            const childResult = this.children[i].find(domainId);
            if (childResult !== undefined) {
                return childResult;
            }
        }
        return undefined;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/models/Domain.js